<template>
	<div class="xs-12 p4">
		<div class="pb2 fs3 fw7">{{ $t("privacy_level") }}</div>
		<j-base-select
			:allowSelectNothing="false"
			class="mb4"
			size="small"
			:options="options"
			v-model="value"
		/>
		<div class="r2 flex xs-middle bg5 bc7 b1 p2 mb4">
			<crm-icon
				v-if="value === 'public'"
				name="warning"
				size="normal"
				class=""
				color="c6"
			/>
			<div v-if="value === 'public'" class="pl2 fs3 lh125 c6">
				{{ $t("public_files_disclaimer") }}
			</div>
			<div v-else class="pl2 fs3 lh125 c6">
				{{ $t("private_files_disclaimer") }}
			</div>
		</div>
		<div class="flex xs-12 xs-center">
			<j-button type="primary" size="small" @click="submit">{{
				$t("submit")
			}}</j-button>
		</div>
	</div>
</template>

<script>
import JBaseSelect from "@/components/JBaseSelect"
import JButton from "@/components/JButton"
import CrmIcon from "@/components/CrmIcon"

export default {
	name: "EditPrivacyFileInput",

	components: { JBaseSelect, JButton, CrmIcon },

	props: {
		isPublic: Boolean
	},

	data() {
		return {
			value: this.isPublic ? "public" : "private",
			options: [
				{ name: this.$t("public"), value: "public" },
				{ name: this.$t("private"), value: "private" }
			]
		}
	},

	methods: {
		submit() {
			this.$emit("input", this.value === "public")
		}
	}
}
</script>
